import { useContext } from "react";
import { useMutation } from "react-query";
import { ApiContext } from "../contexts/ApiContext";
import { ReportingMeasurement } from "../shared/interfaces/ReportingMeasurement";
import { QueryCallbacks } from "../shared/interfaces/ReactQuery";
import { ReportingPayload } from "../shared/interfaces/ReportingPayload";

export function useRemoveReportingMeasurements(callbacks?: QueryCallbacks<ReportingPayload>) {
  const apiContext = useContext(ApiContext);

  return useMutation(
    ["removeReportingMeasurements"],
    async (reportingMeasurement: ReportingMeasurement) =>
      apiContext.utp2ReportsAPIs.removeReportMeasurementSelections(reportingMeasurement),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
